import type { ActionConfig, TaskStepDetail } from "../types";

type AssignableTask = Pick<TaskStepDetail, "assignee" | "availableActions">;

/** UI-gating predicate — true when the viewer may interact with the task as its
 *  assignee. Authoritative when the BE exposes `cancel_assignment` (the viewer
 *  is the assignee) and permissive when the viewer id is unknown (defers to the
 *  BE, which enforces the real authorization on every mutation). NOT a strict
 *  identity check — do not use for authorization decisions. */
export function canViewerActAsAssignee(task: AssignableTask, workflowUserId?: string): boolean {
  if (!task.assignee) return false;
  if (task.availableActions.some((a: ActionConfig) => a.action === "cancel_assignment")) {
    return true;
  }
  return !workflowUserId || task.assignee.id === workflowUserId;
}
